import { useEffect } from "react";
import PropTypes from 'prop-types';

const UnderlineResult = ({ editor, result }) => {
  const temp = [...result];

  temp.sort((a, b) => {
    if (a.offset === b.offset && a.errorType === 'capitalization' && b.errorType === 'spelling') {
        return -1;
    } else {
        return a.offset - b.offset;
    }
  });
  const applyUnderlines = () => {
    temp.forEach(({ offset, deleteCount, errorType }) => {
        const start = offset + 1;
        const end = offset + deleteCount + 1;
        const color = errorType === "spelling" ? '#FF8F00' : '#97539D';
        editor.chain().setTextSelection({ from: start, to: end }).setMark('underline', { color: color }).run();
        editor.chain().setTextSelection({ from: end, to: end }).unsetMark('underline').focus('end').run();
      });
    editor.commands.unsetMark('underline');
  };

  useEffect(() => {
      applyUnderlines();
    }, [editor, result]);

  return null;
};

UnderlineResult.propTypes = {
  editor: PropTypes.shape({
    chain: PropTypes.func.isRequired,
    commands: PropTypes.shape({
      unsetMark: PropTypes.func,
    }),
  }),
  result: PropTypes.array.isRequired,
};

export default UnderlineResult;